import Api from '.';
import { endpoints } from './endpoints';

/**
 * Stage 15 — Payment / fund transfer.
 *
 * In transition: legacy methods (paymentInit, paymentStatus, sendChequeApproval,
 * etc.) target the on-prem backend. New contract uses /payment/initiate,
 * /payment/status, /payment/callback. Legacy methods retired in Phase B.
 */
export default class PaymentApi extends Api {
    // --- Legacy on-prem contract -------------------------------------------
    paymentInit(data) {
        return this.fetch(this.buildUrl(endpoints.payment.init), 'POST', JSON.stringify(data));
    }
    paymentStatus(data) {
        return this.fetch(this.buildUrl(endpoints.payment.status), 'POST', JSON.stringify(data));
    }
    sendChequeApproval(data) {
        return this.fetch(this.buildUrl(endpoints.payment.sendChequeApproval), 'POST', JSON.stringify(data));
    }
    requestChequeStatus(data) {
        return this.fetch(this.buildUrl(endpoints.payment.requestChequeStatus), 'POST', JSON.stringify(data));
    }
    skipOrChequePayment(data) {
        return this.fetch(this.buildUrl(endpoints.payment.skipOrChequePayment), 'POST', JSON.stringify(data));
    }
    getFundTransferDetails(data) {
        return this.fetch(this.buildUrl(endpoints.payment.getFundTransferDetails), 'POST', JSON.stringify(data));
    }
    getSchemeDetailsDirect(data) {
        return this.fetch(this.buildUrl(endpoints.payment.getSchemeDetailsDirect), 'POST', JSON.stringify(data));
    }
    validateDirectLogin(data) {
        return this.fetch(this.buildUrl(endpoints.congratulation.validateDirectLogin), 'POST', JSON.stringify(data));
    }
    insertUpdateSelectedSegment(data) {
        return this.fetch(this.buildUrl(endpoints.payment.insertUpdateSelectedSegment), 'POST', JSON.stringify(data));
    }

    // --- New eKYC 3.0 contract ---------------------------------------------

    /** POST /payment/initiate */
    initiate({ amount, paymentMode, bankIfsc }) {
        return this.fetch(
            this.buildUrl(endpoints.stages.payment.initiate),
            'POST', JSON.stringify({ amount, paymentMode, bankIfsc }),
            { lead: { mode: 'body' } },
        );
    }

    /** POST /payment/status */
    statusCheck(transactionRef) {
        return this.fetch(
            this.buildUrl(endpoints.stages.payment.status),
            'POST', JSON.stringify({ transactionRef }),
            { lead: { mode: 'body' } },
        );
    }

    /** POST /payment/callback */
    callback({ transactionRef, status, bankRefNumber }) {
        return this.fetch(
            this.buildUrl(endpoints.stages.payment.callback),
            'POST', JSON.stringify({ transactionRef, status, bankRefNumber }),
            { lead: { mode: 'body' } },
        );
    }
}
